import { useEffect, useState } from "react";
import "@/App.css";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Preloader } from "@/components/Preloader";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { StatBar } from "@/components/StatBar";
import { ZatPromo } from "@/components/ZatPromo";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Partners } from "@/components/Partners";
import { Booking } from "@/components/Booking";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { Atmosphere } from "@/components/Atmosphere";
import { track } from "@/lib/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return undefined;
    const fire = () => track("pageview");
    fire();
    window.addEventListener("zirsen-consent", fire);
    return () => window.removeEventListener("zirsen-consent", fire);
  }, [location.pathname]);
  return null;
};
import Matrix from "@/pages/Matrix";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

const Landing = ({ ready }) => (
  <div className="relative min-h-screen bg-[#030712] font-body text-slate-900 antialiased">
    <Atmosphere />
    <Navbar />
    <main className="relative z-10">
      <Hero ready={ready} />
      <StatBar />
      <ZatPromo />
      <About />
      <Services />
      <Partners />
      <Faq />
      <Booking />
    </main>
    <Footer />
  </div>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    // Skip Lenis on touch devices — native touch scrolling is smoother and the rAF loop drains mobile GPUs
    if (window.matchMedia("(pointer: coarse)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <LanguageProvider>
      <AnimatePresence>{loading && <Preloader key="preloader" />}</AnimatePresence>
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Landing ready={!loading} />} />
          <Route path="/matrix" element={<Matrix />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/ochrana-osobnich-udaju" element={<Legal kind="privacy" />} />
          <Route path="/obchodni-podminky" element={<Legal kind="terms" />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LanguageProvider>
  );
}

export default App;
